<template>
  <div :class="[$style.controlBar, 'hide-on-print']" data-test="control-bar">
    <slot>
      <FavouriteButton :listingId="listingId" @redirectToLoginPage="emit('redirectToLoginPage')" />
      <HgLink tag="button" type="button" icon="Share" @click="emit('shareButtonClick')">{{
        t('sharing.share')
      }}</HgLink>
      <PrintButton @printButtonClick="emit('printButtonClick')" />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import { HgLink } from '@smg-real-estate/domus';
import { computed } from 'vue';

import FavouriteButton from '@/components/Favourites/FavouriteButton/FavouriteButton.vue';
import PrintButton from '@/components/PrintButton/PrintButton.vue';
import { useListingStore } from '@/store/modules/listing';
import { useI18n } from 'vue-i18n';

const listingStore = useListingStore();
const { t } = useI18n();

defineOptions({
  name: 'ControlBar',
});

const emit = defineEmits<{
  redirectToLoginPage: [];
  shareButtonClick: [];
  printButtonClick: [];
}>();

const listingId = computed(() => {
  return listingStore.listing?.id;
});
</script>

<style lang="scss" module>
@import '@/assets/variables';

.controlBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: $control-bar-mobile-height;

  > *:not(:first-child) {
    margin-left: $space-100;
  }
}

@media (max-width: #{$viewport-md-min - 1}) {
  .controlBar {
    &,
    button span {
      @include body-3;
    }
  }
}

@media (min-width: $viewport-md-min) {
  .controlBar {
    min-height: $control-bar-widescreen-height;

    > *:not(:first-child) {
      margin-left: $space-150;
    }
  }
}
</style>
